import { GuidanceBox } from "@root/shared/components/GuidanceBox";
import { Icon } from "@root/shared/components/Icon";
import { type FC } from "react";
import { colors, fontSize } from "@root/shared/styles/sprinkles.css";
import type { PhotoContestGuidelines } from "@clientFrontend/features/campaign/components/UserPhotoContest/type";
import * as styles from "./styles.css";

type Props = {
  contestGuidelines: PhotoContestGuidelines;
  isVotingPeriodOver: boolean;
};

export const ContestGuideline: FC<Props> = ({ contestGuidelines, isVotingPeriodOver }) => {
  return isVotingPeriodOver ? (
    // 投票期間終了後の表示
    <div className={styles.wrapper}>
      <div className={styles.photoContestTitle}>REJOB PHOTO CONTEST</div>
      <div className={styles.contestGuidelineWrapper}>
        <div className={styles.contestDescriptionContent}>
          <p className={styles.contestDescriptionTitle}>概要</p>
          <p>
            この度、全国のリジョブ会員の美容専門学生を対象に【リジョブフォトコンテスト】を開催いたしました。
          </p>
          <p>
            おかげさまで、無事に投票期間を終了することができました。ご参加、ご投票いただき、誠にありがとうございました。
          </p>
          <p className={styles.votingEndedNotice}>
            スカウトメール送信機能は引き続きご利用いただけますので、ご活用ください。
          </p>
          <p>※作品の被写体は必ずしもコンテスト参加学生本人とは限りません</p>
        </div>
        <div className={styles.guidanceBoxWrapper}>
          <GuidanceBox themeColor="pink">
            <div className={styles.guidanceBoxContentWrapper}>
              <div>
                <p className={styles.fontWeightBold}>スカウトメールの送付について</p>
                <ul className={styles.dotList}>
                  <li className={styles.dotListItem}>
                    コンテスト参加学生へスカウトメールを送付することが可能です
                  </li>
                  <li className={styles.dotListItem}>
                    スカウトメールを送付された場合、お手持ちのスカウトメール残数は減少いたします
                  </li>
                  <li className={styles.dotListItem}>
                    {contestGuidelines.reScoutableDays}
                    日以内にスカウトメールを送ったユーザーへ再送したい場合、前回の送付日から
                    {contestGuidelines.reScoutableDays}日経過後に送れるようになります
                  </li>
                </ul>
              </div>
            </div>
          </GuidanceBox>
        </div>
      </div>
    </div>
  ) : (
    // 投票期間中の表示
    <div className={styles.wrapper}>
      <div className={styles.photoContestTitle}>REJOB PHOTO CONTEST</div>
      <div className={styles.contestGuidelineWrapper}>
        <div className={styles.contestDescriptionContent}>
          <p className={styles.contestDescriptionTitle}>概要</p>
          <p>
            この度、全国のリジョブ会員の美容専門学生を対象に【リジョブフォトコンテスト】を開催いたします。
          </p>
          <p>
            未来の美容業界に携わる美容専門学生に挑戦の機会を提供していきたい、という想いで第
            {contestGuidelines.contestNumber}回目を開催する運びとなりました。
          </p>
          <p>
            リジョブご契約中の企業様におかれましても、投票にご参加いただくという形で、美容専門学生の活躍を応援いただけましたら幸いです。
          </p>
          <p>
            なお、受賞発表ページでは、応援いただいた「審査協力企業」として貴社名を掲載し、貴社のリジョブ求人ページへのリンクを設置させていただきます。
          </p>
        </div>
        <div className={styles.contestScheduleWrapper}>
          <GuidanceBox themeColor="gray">
            <ul className={`${styles.dotList} ${styles.contestDetailScheduleWrapper}`}>
              <li className={styles.dotListItem}>
                投票期間 {contestGuidelines.votingStartDate}～{contestGuidelines.votingEndDate}
                まで
              </li>
              <li className={styles.dotListItem}>
                受賞発表 {contestGuidelines.votingResultPageReleaseDate}予定
              </li>
            </ul>
          </GuidanceBox>
        </div>
        <div className={styles.guidanceBoxWrapper}>
          <GuidanceBox themeColor="pink">
            <div className={styles.guidanceBoxAttention}>
              <Icon name="light" fontSize={fontSize["fs-14"]} color={colors.Biyo} />
              <span className={styles.joinAttention}>注意事項</span>
            </div>
            <div className={styles.guidanceBoxContentWrapper}>
              <div>
                <p className={styles.fontWeightBold}>投票について</p>
                <ul className={styles.dotList}>
                  <li className={styles.dotListItem}>
                    1企業につき各部門
                    <span className={styles.fontWeightBold}>
                      {contestGuidelines.maxVotableCount}票まで
                    </span>
                    、投票いただけます
                  </li>
                  <li className={styles.dotListItem}>同一作品への投票は無効となります</li>
                  <li className={styles.dotListItem}>
                    作品の被写体は必ずしもコンテスト参加学生本人とは限りません
                  </li>
                  <li className={styles.dotListItem}>
                    コンセプト・トータルバランス・独創性・技術力の4つの観点で評価をお願いいたします
                  </li>
                </ul>
              </div>
              <div>
                <p className={styles.fontWeightBold}>コメントについて</p>
                <ul className={styles.dotList}>
                  <li className={styles.dotListItem}>
                    投票いただいた学生へコメントを送付することが可能です
                  </li>
                  <li className={styles.dotListItem}>
                    コメントは弊社で確認後、参加学生に送付させていただきます
                  </li>
                </ul>
              </div>
              <div>
                <p className={styles.fontWeightBold}>スカウトメールの送付について</p>
                <ul className={styles.dotList}>
                  <li className={styles.dotListItem}>
                    コンテスト参加学生へスカウトメールを送付することが可能です
                  </li>
                  <li className={styles.dotListItem}>
                    スカウトメールを送付された場合、お手持ちのスカウトメール残数は減少いたします
                  </li>
                  <li className={styles.dotListItem}>
                    {contestGuidelines.reScoutableDays}
                    日以内にスカウトメールを送ったユーザーへ再送したい場合、前回の送付日から
                    {contestGuidelines.reScoutableDays}日経過後に送れるようになります
                  </li>
                </ul>
              </div>
              <div>
                <p className={styles.fontWeightBold}>企業の掲載・求人連携について</p>
                <ul className={styles.dotList}>
                  <li className={styles.dotListItem}>
                    受賞発表ページにて、ご投票いただいた企業名（サロン名）を掲載させていただきます
                  </li>
                  <li className={styles.dotListItem}>
                    掲載名には貴社のリジョブ求人ページへのリンクを照合させていただきます
                  </li>
                </ul>
              </div>
            </div>
          </GuidanceBox>
        </div>
      </div>
    </div>
  );
};
